import React, { useCallback } from "react";

import { Signing } from "@components";
import { history, routerPath } from "@config";

import "./WaitingRoom.less";

export const WaitingRoom = () => {
  const submitReset = useCallback(() => {
    history.push(routerPath.login);
  }, []);

  return (
    <div className="waiting-room-container">
      <Signing submitReset={submitReset} isWaitingRoom />
    </div>
  );
};
